import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  cardClickEvent,
  mppRecipeCard,
} from '@app/mpp/model/recipe-card-model';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-recipe-card',
  templateUrl: './recipe-card.component.html',
  styleUrls: [
    './recipe-card.component.scss',
    '../../../../styles/shared-mpp-styles.scss',
  ],
})
export class RecipeCardComponent {
  @Input() cardData: mppRecipeCard;
  @Input() platform: PlatformEnum;

  @Output() selectCard = new EventEmitter<mppRecipeCard>();
  @Output() ellipsisClick = new EventEmitter<cardClickEvent>();
  @Output() goToRecipeEvent = new EventEmitter<string>();

  platformRef = PlatformEnum;

  constructor() {}

  onClick = (event: Event) => {
    event.stopPropagation();
    this.selectCard.emit(this.cardData);
  };

  onEllipsisClick = (event: Event) => {
    event.stopPropagation();
    const target = document.getElementById(this.cardData.recipeId);
    this.ellipsisClick.emit({ ...event, ...this.cardData, target });
  };

  onCardClick = (event: Event) => {
    event.stopPropagation();
    this.goToRecipeEvent.emit(this.cardData.recipeId);
  };
}
